import React, { forwardRef } from 'react';
import styled from 'styled-components';
import Color from 'color';
import { useTheme, Typography } from '@material-ui/core';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';

const BigButtonComponent = ({ icon, colour, children, ...props }, ref) => {
  const { palette } = useTheme();
  const mainColour = palette[colour].main;
  return (
    <StyledButton ref={ref} colour={mainColour} {...props}>
      
          {icon}

      <Text variant='h5'>{children}</Text>
    </StyledButton>
  );
};



const StyledButton = styled.div`
  display: flex;
  width: 99%;
  height: 250px;
  align-items: center;
  color: ${(props) => props.colour};
  border: ${(props) =>
    `${props.isUpload ? '2px dashed' : '1px solid'} ${props.colour}`};
  border-radius: 1rem;
  cursor: pointer;
  &:hover {
    background: ${(props) => Color(props.colour).fade(0.8).string()};
  }
  &:active {
    background: ${(props) =>
      Color(props.colour).darken(0.95).fade(0.5).string()};
  }
`;

const Text = styled(Typography)`
  font-size: 2rem;
`;

// const Icon = styled.div`
//   padding: 8rem 4rem 8rem 8rem;
// `;

const BigButton = forwardRef(BigButtonComponent);
export default BigButton;
